import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, throwError} from 'rxjs';
import {catchError, filter, switchMap, take} from 'rxjs/operators';
import {Router} from '@angular/router';
import {NotificationService} from '@shared/services/notification.service';
import {AuthService} from '@modules/authentication/services/auth.service';
import {LocalStorage} from '@core/storage/storage';
import {LOCAL_STORAGE} from '@core/constant/storage.constant';


const TOKEN_HEADER_KEY = 'Authorization';

@Injectable()
export class CustomHttpInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);


  constructor(
    private notiService : NotificationService,
    private authService: AuthService,
    private router: Router) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const url = req.url.toLowerCase();
    let accessToken = LocalStorage.getItem(LOCAL_STORAGE.KEY.ACCESS_TOKEN);
    if (accessToken && !url.includes('login') && !url.includes('refresh-token')) {
      req = this.addTokenHeader(req, accessToken);
    }
    return next.handle(req).pipe(
      catchError((error) => {
        if (403 == error.status) {
          this.notiService.warning('Bạn không có quyền truy cập api');
        }
        if (401 == error.status) {
          return this.handle401Error(req, next);
        }

        if (error.error?.messageCode === "WEBSITE_NOT_SUPPORT") {
          LocalStorage.clear();
          this.notiService.warning('Bạn không có quyền cấu hình website này');
          this.router.navigate(['/auth/login']);
        }
        return throwError(error);
      })
    )

  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);
      if (this.authService.isAuthenticated()) {
        return this.authService.refreshToken().pipe(
          switchMap(res => {
            this.isRefreshing = false;
            this.refreshTokenSubject.next(res.access_token);
            return next.handle(this.addTokenHeader(request, res.access_token));
          }),
          catchError((err) => {
            this.isRefreshing = false;
            LocalStorage.clear();
            this.router.navigate(['/auth/login']);
            this.notiService.warning('Phiên đăng nhập hết hạn');
            return throwError(() => err);
          })
        );
      } else {
        LocalStorage.clear();
        this.router.navigate(['/auth/login']);
        this.notiService.warning('Phiên đăng nhập hết hạn');
      }
    }
    return this.refreshTokenSubject.pipe(
      filter(token => token !== null),
      take(1),
      switchMap((token) => next.handle(this.addTokenHeader(request, token)))
    );
  }

  private addTokenHeader(request: HttpRequest<any>, accessToken: string) {
    return request.clone({headers: request.headers.set(TOKEN_HEADER_KEY, 'Bearer ' + accessToken)});
  }
}
